export default {"src":"/_next/static/media/medical-specialities.68fdce1b.svg","height":68,"width":68,"blurWidth":0,"blurHeight":0};